import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, type ButtonProps } from '@mui/material';
import { ClearOutlined } from '@mui/icons-material';

export const ResetButton: FC<ButtonProps> = ({ children, ...props }) => {
  const { t } = useTranslation();

  return (
    <Button variant="outlined" startIcon={<ClearOutlined />} {...props}>
      {children ?? t('Reset')}
    </Button>
  );
};
